var React = require('react');

function TreeExpand (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"surface1"},React.createElement("path",{"style":{},"d":"M 13 15.40625 L 21.765625 6.820313 C 22.15625 6.4375 22.78125 6.441406 23.171875 6.828125 L 24.707031 8.363281 C 25.097656 8.757813 25.097656 9.390625 24.703125 9.78125 L 13.707031 20.707031 C 13.511719 20.902344 13.257813 21 13 21 C 12.742188 21 12.488281 20.902344 12.292969 20.707031 L 1.296875 9.78125 C 0.902344 9.390625 0.902344 8.757813 1.292969 8.363281 L 2.828125 6.828125 C 3.21875 6.441406 3.84375 6.4375 4.234375 6.820313 Z "})));
}

TreeExpand.displayName = "TreeExpand";

TreeExpand.defaultProps = {"viewBox":"0 0 26 26","version":"1.1","width":"26","height":"26","style":{"fill":"rgb(255, 255, 255)"}};

module.exports = TreeExpand;

TreeExpand.default = TreeExpand;



//////////////////
// WEBPACK FOOTER
// ./src/components/tree-expand.svgc
// module id = ./src/components/tree-expand.svgc
// module chunks = 4016850265702045000